jQuery(document).on('ready', function () {
    jQuery('.wm-accordion__title').on('click', function () {
        jQuery(this).toggleClass('-active').siblings('.wm-accordion__inner').slideToggle();
    });
});
